/**
 * Created by idea on 14/04/2017.
 */
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

declare var $: any;

@Injectable()
export class ExportService {
  headers: Headers;
  url = environment.qrcode_url;
  url_avs = environment.api_evs;

  constructor(
    private http: Http
  ) {
    const token = localStorage.getItem('Access-Token');
    const lang = localStorage.getItem('lang');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'accept-language': `${lang}`
    });
  }

  /**Tuanba: 9-1-2023: Xuất báo cáo chi tiết mã màn lịch sử kích hoạt tab 2**/
  exportReport(body) {
    const token = localStorage.getItem('Access-Token');
    const lang = localStorage.getItem('lang');
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'accept-language': `${lang}`
    });
    return this.http.post(`${this.url_avs}/qr-core-aps/export`, body, { headers: headers, })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  public stampBatchesList(data?: any) {
    return this.http.get('/batches', data);
  }

  exportReportLogScan(data?: any): Observable<any> {
    const token = localStorage.getItem('Access-Token');
    const lang = localStorage.getItem('lang');
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'accept-language': `${lang}`
    });
    return this.http.get(`${this.url_avs}/qr_aps/scan/stamps/export`, {
      headers: headers,
      params: data,
    })
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  exportDetailStampBox(idBox: number | string, data?: any): Observable<any> {
    const type = 'application/vnd.ms-excel';
    const token = localStorage.getItem('Access-Token');
    const lang = localStorage.getItem('lang');
    const headers = new Headers({
      'Accept': type,
      'Authorization': `Bearer ${token}`,
      'accept-language': `${lang}`
    });
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
      params: data
    });
    return this.http.get(`${this.url_avs}/qr_aps/box/stamps/export?box_id=${idBox}`, options)
      .map((res) => {
        return res.json();
      })
      .catch((err) => {
        throw err.json();
      });
  }

  // exportDetailStampBox(idBox: number | string, data?: any): Observable<any> {
  //   const token = localStorage.getItem('Access-Token');
  //   const headers = new Headers({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${token}`,
  //     'responseType': 'blob'
  //   });
  //   return this.http.get(`${this.url_avs}/qr_aps/box/stamps/export?box_id=${idBox}`, {
  //     headers: headers,
  //     params: data,
  //   })
  //     .map((res) => {
  //       return res.json();
  //     })
  //     .catch((err) => {
  //       throw err.json();
  //     });
  // }

  // /**Tuanba: 4-9-2025: Xuất báo cáo danh sách sn phẩm**/
  // exportProduct(body) {
  //   const token = localStorage.getItem('Access-Token');
  //   const headers = new Headers({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${token}`
  //   });
  //   return this.http.post(`${this.url_avs}/qr-core-aps/export`, body, {headers: headers})
  //     .map((res) => {
  //       return res.json();
  //     })
  //     .catch((error: any) => {
  //       throw error.json();
  //     });
  // }


  exportReportStatistic(body) {
    return this.http.post(`${this.url_avs}/qr-core-aps/export/statistic`, body, { headers: this.headers, })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/Export.service.ts